import { WaiverEventType, WaiverEvents } from '@prisma/client';
import { formatInTimeZone } from 'date-fns-tz';
import { WaiverRequestWithCustomerAndEvents } from '../../../../types/waivers';

export type FormRowStatus =
  | { kind: 'signed'; signedAt: Date }
  | { kind: 'awaiting'; sentAt: Date };

export interface FormRowContent {
  name: string;
  subline: string;
  status: FormRowStatus;
}

function findEventTimestamp(
  events: WaiverEvents[],
  type: WaiverEventType,
): Date | null {
  const event = events.find(candidate => candidate.type === type);
  return event ? new Date(event.timestamp) : null;
}

function describeFormRowStatus(events: WaiverEvents[]): FormRowStatus | null {
  const signedAt = findEventTimestamp(events, WaiverEventType.COMPLETED);
  if (signedAt) return { kind: 'signed', signedAt };

  const sentAt = findEventTimestamp(events, WaiverEventType.SENT);
  if (sentAt) return { kind: 'awaiting', sentAt };

  return null;
}

export function describeFormRow(
  waiverRequest: WaiverRequestWithCustomerAndEvents,
  timezone: string,
): FormRowContent | null {
  const status = describeFormRowStatus(waiverRequest.events);
  if (!status) return null;

  const verb = status.kind === 'signed' ? 'Signed' : 'Sent';
  const dateLabel = formatInTimeZone(
    status.kind === 'signed' ? status.signedAt : status.sentAt,
    timezone,
    'MMMM d, yyyy',
  );
  const appointmentStartDateTime = waiverRequest.appointment.startDateTime;
  const appointmentDateLabel = appointmentStartDateTime
    ? formatInTimeZone(
        new Date(appointmentStartDateTime),
        timezone,
        'MMM d, yyyy',
      )
    : null;

  return {
    name: waiverRequest.waiver.name,
    subline: appointmentDateLabel
      ? `${verb} ${dateLabel} · ${appointmentDateLabel} appointment`
      : `${verb} ${dateLabel}`,
    status,
  };
}
